module.exports = __webpack_public_path__ + "static/media/comments-bg.0f0fde89.svg";